import * as React from "react";
import { css } from "emotion";
const contentAreaClass = css({
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
});
export const ContentArea = (props) => React.createElement("div", { className: contentAreaClass }, props.children);
export default ContentArea;
//# sourceMappingURL=contentarea.js.map